import React, { FC } from 'react';
import { Select as AntdSelect } from 'antd';
import { SelectOptions } from 'shared/types';
import { BaseOptionType } from 'antd/es/select';

export interface SelectProps {
  options: SelectOptions
  value: string
  readonly?: boolean
}

export const Select:FC<SelectProps> = React.memo((props) => {
  const { readonly, value, options } = props;
  const selectOptions: BaseOptionType[] = Object.keys(options).map((key: string) => ({ name: key, value: options[key] }));
  if (readonly) {
    const displayValue = selectOptions.find((item) => item.name === value)?.value;
    return displayValue || value;
  }
  return <AntdSelect options={selectOptions} />;
});
